
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"18","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.31 11.917l7.607-7.606-1.06-1.06-7.607 7.606v1.06h1.06zm.622 1.5H2.75v-3.182l8.576-8.576a.75.75 0 011.06 0l2.122 2.121a.75.75 0 010 1.061l-8.576 8.576zm-3.182 1.5h13.5v1.5H2.75v-1.5z","fill":"#910000"}})])
          )
        }
      }
    